import React, { useContext, useCallback, useState } from 'react';
import { useMutation } from 'react-query';

import SearchBar from 'components/searchBar/SearchBar';
import { STANDARD_PAGE_SIZE } from 'components/table/models';
import TableLoader from 'components/table/TableLoader';
import { ModalContext } from 'contexts/ModalContext';
import { cleanOfferLocalStorage } from 'helpers/connectToLocalStorage';
import useGetCorporateOffers from 'modules/offers/hooks/useGetCorporateOffers';

import { OfferCategory, OFFERS_SORT_BY_BE } from '../../models';
import {
  deleteCorporateOffer,
  getCorporateOffers,
} from '../../offersServices/CorporateOffersService';
import CreateOfferModal from '../CreateOfferModal';

import CorporateTable from './CorporateTable';

const CorporateOffers = () => {
  const deleteOffer = useMutation(deleteCorporateOffer);
  const [nameForSearching, setNameForSearching] = useState('');
  const [sortByListItemIndex, setSortByListItemIndex] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(STANDARD_PAGE_SIZE);
  const [isCreatingModalOpen, setIsCreatingModalOpen] = useState(false);

  const { isModalOpen, setModalOpen } = useContext(ModalContext);

  const { data, isLoading } = useGetCorporateOffers(
    [nameForSearching, sortByListItemIndex, page, pageSize],
    () => {
      return getCorporateOffers({
        data: {
          page: page || 1,
          pageSize,
          search: nameForSearching,
          sortBy: OFFERS_SORT_BY_BE[sortByListItemIndex],
        },
      });
    }
  );

  const chooseTypeOfSorting = useCallback((index: number) => {
    setPage(1);
    setSortByListItemIndex(index);
  }, []);

  const searchByOfferName = useCallback((name: string) => {
    setPage(1);
    setNameForSearching(name);
  }, []);

  const toggleCreatingModalWindow = useCallback(
    (id?: string) => {
      setModalOpen(false);
      setIsCreatingModalOpen(false);
      cleanOfferLocalStorage();

      if (id) {
        deleteOffer.mutate({ corporateOfferId: id });
      }
    },
    [deleteOffer, setModalOpen]
  );

  return (
    <>
      <SearchBar
        title="Offers:"
        buttonText="Create offer"
        nameToFilter={nameForSearching}
        openModalWindow={() => setIsCreatingModalOpen(true)}
        activeFilterParameter="Group"
        setNewNameToFilter={searchByOfferName}
      />
      {(isCreatingModalOpen || isModalOpen) && (
        <CreateOfferModal
          activeOfferCategory={OfferCategory.Group}
          closeModalWindow={toggleCreatingModalWindow}
        />
      )}
      {isLoading ? (
        <TableLoader />
      ) : (
        <CorporateTable
          data={data?.items}
          dataAmount={data?.totalCount || 0}
          page={page}
          setPage={setPage}
          activePageSize={pageSize}
          setActivePageSize={setPageSize}
          sortOffers={chooseTypeOfSorting}
          sortByListItemIndex={sortByListItemIndex}
        />
      )}
    </>
  );
};

export default CorporateOffers;
